module.exports = __webpack_public_path__ + "img/DAVID_CANNON_41-rs.f7a84a91.jpg";